import { noop } from 'lodash';
import { useState } from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import styled from 'styled-components';

export const ControlledTabs = styled(
  ({ tabs, children = noop, className, onTabChange, activeTab }) => {
    return (
      <>
        <Nav tabs className={className}>
          {tabs.map(({ value, display }) => (
            <NavItem className="cursor-pointer" key={value}>
              <NavLink
                className={activeTab === value ? 'active' : ''}
                onClick={() => onTabChange(value)}
              >
                {display}
              </NavLink>
            </NavItem>
          ))}
        </Nav>
        {children(activeTab)}
      </>
    );
  },
)`
   {
    .nav-link,
    .nav-link.active {
      border: none;
      background-color: transparent;
      padding: var(--content-y-padding) var(--cell-padding);
      border-radius: 0;
      &:hover {
        background-color: rgba(33, 33, 33, 0.03);
        border-bottom: 2px solid rgba(33, 33, 33, 0.03);
      }
    }
    .nav-link.active,
    .nav-link.active:hover {
      color: var(--text-color);
      font-weight: bold;
      border-bottom: 2px solid rgba(33, 33, 33, 0.5);
      background-color: transparent;
    }
  }
`;

export const UncontrolledTabs = ({ tabs, ...props }) => {
  const [activeTab, setActiveTab] = useState(tabs[0].value);
  return (
    <ControlledTabs
      tabs={tabs}
      activeTab={activeTab}
      onTabChange={setActiveTab}
      {...props}
    />
  );
};
